@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.favorites
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint


object DeletePassengerFavoritePointEndpoint :
    EndPoint<DeletePassengerFavoritePointEndpoint.Request, DeletePassengerFavoritePointEndpoint.Response>() {
    class Request(
        val favoritePointId: KmmLong
    )

    class Response
}